import { useContext, useState } from 'react'

import { Modal, Input } from '../ui_new'
import { Close } from '../../assets/icons'
import { SingleDocumentContext } from '../../context'
import { Cancel, CheckCircle } from '@mui/icons-material'

const SubmitCommentsModal = ({ onClose, onConfirm, onCancel }) => {

  const { document } = useContext(SingleDocumentContext)

  const [generalComment, setGeneralComment] = useState('')

  const handleConfirm = () => {
    onConfirm(generalComment)
  }

  const handleCancel = () => {
    onCancel()
  }

  const negotiator = document?.author || {}
  const negotiatorName = `${negotiator.firstname || ''}${negotiator.firstname ? ' ' : ''}${negotiator.lastname || ''}`
  const descriptionText = `Vous êtes sur le point de partager les commentaires du document à votre négociateur ${negotiatorName}.\nVous pouvez y ajouter un commentaire général si vous le souhaitez.`
  const questionText = 'Êtes-vous sûr de vouloir continuer ?'

  const cancelLabel = 'Annuler'
  const confirmLabel = 'Valider'

  return (
    <Modal onClose={onClose} className="modal-v2 modal-v2--mid">
      <div className="modal-v2__heading modal-v2__heading--light modal-v2__heading--small">
        <h2>Partage des commentaires</h2>
        <div className="buttons-row">
          <button
            className="btn btn--small btn--light btn--border-primary btn--border-radius-sm btn--square"
            onClick={onClose}
          >
            <Close />
          </button>
        </div>
      </div>
      <div className='modal-v2__body'>
      {descriptionText && <p className="share-warning--text">{descriptionText}</p>}
      {questionText && <p className="share-warning--question">{questionText}</p>}
        <div className="comment-form">
          <div className="input-wrapper">
            <Input
              value={generalComment}
              type="string"
              onChange={(e) => setGeneralComment(e.target.value)}
              className={generalComment ? 'not-empty' : ''}
              label={'Ajouter un commentaire général'}
              placeholder=' - '
              required />
          </div>
        </div>
        <div className="modal-v2__buttons-footer">
          {cancelLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-danger"
              onClick={handleCancel}
            >
              <Cancel fontSize="small" />
              {cancelLabel}
            </button>
          )}
          {confirmLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-success"
              onClick={handleConfirm}
            >
              <CheckCircle />
              {confirmLabel}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default SubmitCommentsModal
